export default function Footer() {
  return (
    <footer className="bg-[#0D0C0A] pt-16 pb-10 md:pt-[140px] md:pb-[60px] relative overflow-hidden">

      {/* Watermark */}
      <div
        className="absolute bottom-[-40px] left-1/2 -translate-x-1/2 font-serif text-white/[0.025] select-none pointer-events-none whitespace-nowrap"
        style={{
          fontSize: 'clamp(60px, 18vw, 240px)',
          fontFamily: '"Playfair Display", Georgia, serif',
          letterSpacing: '0.12em',
        }}
      >
        ANTEROOM
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-[80px] relative z-10">

        {/* Top wordmark */}
        <div className="border-b border-[#2A2825] pb-10 mb-10 md:pb-[80px] md:mb-[80px]">
          <div className="flex flex-col items-center text-center gap-6 md:flex-row md:items-end md:justify-between md:text-left md:gap-0">
            <div>
              <p
                className="font-serif text-[#F8F6F3]"
                style={{
                  fontSize: 'clamp(32px, 6vw, 80px)',
                  fontFamily: '"Playfair Display", Georgia, serif',
                  letterSpacing: '0.12em',
                  lineHeight: 1,
                }}
              >
                ANTEROOM
              </p>
              <p className="text-[#C9A96E] font-sans uppercase mt-[10px]" style={{ fontSize: '9px', letterSpacing: '0.4em' }}>
                Sovereign Advisory · Nairobi · New York · Washington DC
              </p>
            </div>
            <p
              className="text-[#F8F6F3]/35 font-serif max-w-[400px] text-center md:text-right"
              style={{ fontSize: 'clamp(14px, 2vw, 18px)', fontStyle: 'italic', fontFamily: '"Playfair Display", Georgia, serif', lineHeight: 1.6 }}
            >
              "The Anteroom is where power is prepared."
            </p>
          </div>
        </div>

        {/* Links grid */}
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 md:gap-[80px] mb-10 md:mb-[80px]">

          {/* Presence */}
          <div>
            <p className="text-[#F8F6F3]/30 text-[10px] uppercase tracking-[0.3em] font-sans mb-6 md:mb-[32px]">Presence</p>
            <div className="space-y-5 md:space-y-[28px]">
              {[
                { city: 'Nairobi', region: 'East Africa' },
                { city: 'New York', region: 'North America' },
                { city: 'Washington DC', region: 'North America' },
              ].map((office, i) => (
                <div key={i}>
                  <p
                    className="font-serif text-[#F8F6F3]/80 mb-[4px]"
                    style={{ fontSize: '14px', fontFamily: '"Playfair Display", Georgia, serif', letterSpacing: '0.06em' }}
                  >
                    {office.city}
                  </p>
                  <p className="text-[#C9A96E]/50 font-sans uppercase" style={{ fontSize: '9px', letterSpacing: '0.2em' }}>
                    {office.region}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Disciplines */}
          <div>
            <p className="text-[#F8F6F3]/30 text-[10px] uppercase tracking-[0.3em] font-sans mb-6 md:mb-[32px]">Disciplines</p>
            <nav className="space-y-4 md:space-y-[20px]">
              {['Media Mastery', 'Executive Presence', 'Message Architecture', 'High-Stakes Briefing'].map((s) => (
                <a
                  key={s}
                  href="#services"
                  className="block text-[#F8F6F3]/60 text-[13px] md:text-[14px] font-sans hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
                >
                  {s}
                </a>
              ))}
            </nav>
          </div>

          {/* Clientele */}
          <div>
            <p className="text-[#F8F6F3]/30 text-[10px] uppercase tracking-[0.3em] font-sans mb-6 md:mb-[32px]">Clientele</p>
            <nav className="space-y-4 md:space-y-[20px]">
              {['Heads of State', 'Cabinet Ministers', 'Members of Parliament', 'Business Elites', 'NGO Leadership'].map((c) => (
                <a
                  key={c}
                  href="#who-we-serve"
                  className="block text-[#F8F6F3]/60 text-[13px] md:text-[14px] font-sans hover:text-[#C9A96E] transition-colors duration-300 cursor-pointer"
                >
                  {c}
                </a>
              ))}
            </nav>
          </div>

          {/* Inquiry */}
          <div className="col-span-2 md:col-span-1 flex flex-col items-center text-center md:items-start md:text-left">
            <p className="text-[#F8F6F3]/30 text-[10px] uppercase tracking-[0.3em] font-sans mb-6 md:mb-[32px]">Confidential Inquiry</p>
            <p className="text-[#F8F6F3]/50 text-[12px] md:text-[13px] font-sans leading-[1.8] mb-8 md:mb-[40px] max-w-[280px] md:max-w-none">
              For leaders who understand that preparation is not optional — it is the difference between legacy and obscurity.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 border border-[#C9A96E]/40 text-[#C9A96E] font-sans uppercase px-5 py-3 md:px-[32px] md:py-[16px] hover:bg-[#C9A96E]/10 transition-all duration-300 whitespace-nowrap cursor-pointer w-full md:w-auto"
              style={{ fontSize: '9px', letterSpacing: '0.28em' }}
            >
              Initiate Contact
              <i className="ri-arrow-right-line text-[14px]" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#2A2825] pt-8 flex flex-col items-center gap-5 md:flex-row md:justify-between md:items-center md:gap-0">
          <p className="text-[#F8F6F3]/25 font-sans text-center md:text-left" style={{ fontSize: '11px', letterSpacing: '0.06em' }}>
            © 2026 Anteroom Sovereign Advisory · All Rights Reserved
          </p>
          <div className="flex gap-6 flex-wrap justify-center md:justify-end">
            {['Privacy Policy', 'Terms of Engagement'].map((l) => (
              <a
                key={l}
                href="#privacy"
                className="text-[#F8F6F3]/25 font-sans hover:text-[#F8F6F3]/50 transition-colors duration-300 cursor-pointer"
                style={{ fontSize: '11px', letterSpacing: '0.06em' }}
              >
                {l}
              </a>
            ))}
          </div>
        </div>

      </div>
    </footer>
  );
}
